import styled from '@emotion/styled';
import ReactCountryFlag from 'react-country-flag';
import theme from 'App.theme';

// Container for the modal
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.layout.spacing.medium};
  padding: 0 16px;
  margin: 0 0 -16px;
  position: relative;
`;

// Flag
export const Flag = styled(ReactCountryFlag)`
  margin-right: 0.5rem;
  width: 21px;
  height: 100%;
`;

export const Title = styled('div')`
  margin-bottom: ${theme.layout.spacing.small};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${theme.colours.black};
`;

export const Description = styled('div')`
  font-size: 14px;
  line-height: 22px;
  color: ${theme.greys.GREY3};
  word-wrap: break-word;
`;
